import { SplitApiSettings } from "./SplitApiSetting";
import { API_END_POINTS } from "./ApiEndpoints";

export const api = SplitApiSettings.injectEndpoints({
  reducerPath: "api",
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    /////////////////////////////<===MUTATIONS===>//////////////////////////////
    registerUser: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.registerUser,
        method: "POST",
        body: data,
      }),
    }),

    loginUser: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.loginUser,
        method: "POST",
        body: data,
      }),
    }),
    destinationPopup: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.destinationPopup,
        method: "POST",
        body: data,
      }),
    }),
    addPackingList: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.addPackingList,
        method: "POST",
        body: data,
      }),
    }),
    packingDefault: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.packingDefault,
        method: "POST",
        body: data,
      }),
    }),
    packingDefaultEdit: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_END_POINTS.packingDefault}/${id}`,
        method: "PUT",
        body: data,
      }),
    }),
    editPackingList: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_END_POINTS.addPackingList}/${id}`,
        method: "PUT",
        body: data,
      }),
    }),
    blockPacking: builder.mutation({
      query: ({ id }) => ({
        url: `${API_END_POINTS.blockPacking}/${id}`,
        method: "PATCH",
      }),
    }),
    packingStatus: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_END_POINTS.packingStatus}/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    duplicatePacking: builder.mutation({
      query: ({ id }) => ({
        url: `${API_END_POINTS.duplicatePacking}/${id}`,
        method: "POST",
      }),
    }),
    deletePackingList: builder.mutation({
      query: ({ id }) => ({
        url: `${API_END_POINTS.addPackingList}/${id}`,
        method: "DELETE",
      }),
    }),
    blockTraveller: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_END_POINTS.blockTraveller}${id}`,
        method: "POST",
        body: data,
      }),
    }),
    savePackingList: builder.mutation({
      query: ({ id }) => ({
        url: `${API_END_POINTS.savePackingList}${id}`,
        method: "POST",
        // body: data,
      }),
    }),
    unSavePackingList: builder.mutation({
      query: ({ id }) => ({
        url: `${API_END_POINTS.unSavePackingList}${id}`,
        method: "POST",
        // body: data,
      }),
    }),
    readNotification: builder.mutation({
      query: ({ id }) => ({
        url: `${API_END_POINTS.readNotification}${id}`,
        method: "POST",
        // body: data,
      }),
    }),
    addTag: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.addUpdatetag,
        method: "POST",
        body: data,
      }),
    }),

    updateTag: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_END_POINTS.addUpdatetag}/${id}`,
        method: "PUT",
        body: data,
      }),
    }),
    topSection: builder.mutation({
      query: ({ data }) => ({
        url: `${API_END_POINTS.topSection}`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteTag: builder.mutation({
      query: ({ id }) => ({
        url: `${API_END_POINTS.addUpdatetag}/${id}`,
        method: "DELETE",
        // body: data,
      }),
    }),
    updateProfile: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.UpdateProfile,
        method: "POST",
        body: data,
      }),
    }),
    addPrimaryBadge: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.addPrimaryBadge,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "primaryBadge" }]
    }),
    addSpecialBadge: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.addSpecialBadge,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "specialBadge" }]
    }),
    deleteBadges: builder.mutation({
      query: (id) => ({
        url: `${API_END_POINTS.deleteBadges}${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "specialBadge" }, { type: "primaryBadge" }]
    }),
    assignPrimaryBadge: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_END_POINTS.assignPrimaryBadge}${id}`,
        method: "POST",
        body: data
      }),
      invalidatesTags: [{ type: "TravellerProfileTable" }]
    }),
    assignSpecialBadge: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_END_POINTS.assignSpecialBadge}${id}`,
        method: "POST",
        body: data
      }),
      invalidatesTags: [{ type: "TravellerProfileTable" }]
    }),
    assignPoints: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_END_POINTS.assignPoints}${id}/points`,
        method: "POST",
        body: data
      }),
      invalidatesTags: [{ type: "TravellerProfileTable" }]
    }),

    /////////////////////////////<===QUERIES===>////////////////////////////////

    getProducts: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getProducts,
          method: "GET",
        };
      },
    }),

    getAuthUser: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getAuthUser,
          method: "GET",
        };
      },
    }),
    getDestination: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getDestination,
          method: "GET",
        };
      },
    }),
    getTags: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getTags,
          method: "GET",
        };
      },
    }),
    getPackingListSearch: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getPackingListSearch}`,
          method: "GET",
          params
        };
      },
    }),
    getDashboardSearch: builder.query({
      query: () => {
        return {
          url: `${API_END_POINTS.getDashboardSearch}`,
          method: "GET",
        };
      },
    }),
    getDashboardStats: builder.query({
      query: () => {
        return {
          url: `${API_END_POINTS.getDashboardStats}`,
          method: "GET",
        };
      },
    }),
    getProfileDistribution: builder.query({
      query: () => {
        return {
          url: `${API_END_POINTS.getProfileDistribution}`,
          method: "GET",
        };
      },
    }),
    getCitiesPerCountry: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getCitiesPerCountry}`,
          method: "GET",
          params
        };
      },
    }),
    getSpendingMetrics: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getSpendingMetrics}`,
          method: "GET",
          params
        };
      },
    }),
    getTechItems: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getTechItems}`,
          method: "GET",
          params
        };
      },
    }),
    getToiletryDistribution: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getToiletryDistribution}`,
          method: "GET",
          params
        };
      },
    }),
    getActivity: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getActivity}`,
          method: "GET",
          params
        };
      },
    }),
    getOrderedBySaves: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getOrderedBySaves}`,
          method: "GET",
          params
        };
      },
    }),
    getDashboardTable: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getDashboardTable}`,
          method: "GET",
          params
        };
      },
    }),
    getTopTenPacking: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getTopTenPacking}`,
          method: "GET",
          params
        };
      },
    }),
    getPackingListAnalytics: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getPackingListAnalytics}`,
          method: "GET",
          params
        };
      },
    }),
    getDestinationAnalytics: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getDestinationAnalytics}`,
          method: "GET",
          params
        };
      },
    }),
    getMonthlyGrowthRate: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getMonthlyGrowthRate}`,
          method: "GET",
          params
        };
      },
    }),
    getActivityDistribution: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getActivityDistribution}`,
          method: "GET",
          params
        };
      },
    }),
    getNationalityComposition: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getNationalityComposition}`,
          method: "GET",
          params
        };
      },
    }),
    getPackingStyleDistribution: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getPackingStyleDistribution}`,
          method: "GET",
          params
        };
      },
    }),
    getTravellerProfileTable: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getTravellerProfileTable}`,
          method: "GET",
          params
        };
      },
      providesTags: [{ type: "TravellerProfileTable" }],
    }),
    getPackingListStatsCard: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getPackingListStatsCard}`,
          method: "GET",
          params
        };
      },
    }),
    getFilter: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getFilter}`,
          method: "GET",
          params
        };
      },
    }),
    getPackingListById: builder.query({
      query: (id) => {
        return {
          url: `${API_END_POINTS.getPackingListById}/${id}`,
          method: "GET",
        };
      },
    }),
    getUserById: builder.query({
      query: (id) => {
        return {
          url: `${API_END_POINTS.getUserById}/${id}`,
          method: "GET",
        };
      },
    }),
    getPackingListSearh: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getPackingListSearh}`,
          method: "GET",
          params
        };
      },
    }),
    getTravellState: builder.query({
      query: () => {
        return {
          url: `${API_END_POINTS.getTravellState}`,
          method: "GET",
        };
      },
    }),
    getCountSavedList: builder.query({
      query: () => ({
        url: `${API_END_POINTS.countsavedlist}`,
        method: "GET",
      }),
    }),
    getSavedPackingList: builder.query({
      query: (params) => ({
        url: `${API_END_POINTS.getSavedPackingList}`,
        method: "GET",
        params
      }),
    }),
    getAllNotification: builder.query({
      query: () => ({
        url: `${API_END_POINTS.getAllNotification}`,
        method: "GET",
      }),
    }),
    getUnReadAllNotification: builder.query({
      query: () => ({
        url: `${API_END_POINTS.getUnReadAllNotification}`,
        method: "GET",
      }),
    }),
    packingDefaultGet: builder.query({
      query: () => ({
        url: `${API_END_POINTS.packingDefault}`,
        method: "GET",
      }),
    }),
    partialPacking: builder.query({
      query: () => ({
        url: `${API_END_POINTS.partialPacking}`,
        method: "GET",
      }),
    }),
    perfectPacking: builder.query({
      query: () => ({
        url: `${API_END_POINTS.perfectPacking}`,
        method: "GET",
      }),
    }),
    getTopSection: builder.query({
      query: () => ({
        url: `${API_END_POINTS.getTopSection}`,
        method: "GET",
      }),
    }),
    primaryBadges: builder.query({
      query: () => ({
        url: `${API_END_POINTS.primaryBadges}`,
        method: "GET",
      }),
      providesTags: [{ type: "primaryBadge" }],
    }),

    specialBadges: builder.query({
      query: () => ({
        url: `${API_END_POINTS.specialBadges}`,
        method: "GET",
      }),
      providesTags: [{ type: "specialBadge" }],
    }),
    genderPacking: builder.query({
      query: () => ({
        url: `${API_END_POINTS.genderPacking}`,
        method: "GET",
      }),
    }),

  }),

  overrideExisting: true,
  // Add defaultOptions to disable caching
  defaultOptions: {
    queries: {
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      refetchOnReconnect: true,
      refetchOnFocus: true,
    },
    mutations: {},
  },
});

export const {
  /////////////////////////////<===MUTATIONS===>//////////////////////////////
  // useupdaterUserMutation,
  useRegisterUserMutation,
  useLoginUserMutation,
  useDestinationPopupMutation,
  useAddPackingListMutation,
  usePackingDefaultMutation,
  usePackingDefaultEditMutation,
  useEditPackingListMutation,
  useBlockPackingMutation,
  usePackingStatusMutation,
  useDuplicatePackingMutation,
  useDeletePackingListMutation,
  useBlockTravellerMutation,
  useAddTagMutation,
  useUpdateTagMutation,
  useDeleteTagMutation,
  useUpdateProfileMutation,
  useSavePackingListMutation,
  useUnSavePackingListMutation,
  useReadNotificationMutation,
  useTopSectionMutation,
  useAddPrimaryBadgeMutation,
  useAddSpecialBadgeMutation,
  useDeleteBadgesMutation,
  useAssignPrimaryBadgeMutation,
  useAssignSpecialBadgeMutation,
  useAssignPointsMutation,
  /////////////////////////////<===QUERIES===>////////////////////////////////
  useGetProductsQuery,
  useGetAuthUserQuery,
  useGetDestinationQuery,
  useGetTagsQuery,
  useGetTravellStateQuery,
  useLazyGetPackingListSearchQuery,
  useGetPackingListByIdQuery,
  useGetUserByIdQuery,
  useLazyGetUserByIdQuery,
  useLazyGetPackingListByIdQuery,
  useLazyGetDashboardSearchQuery,
  useLazyGetDashboardStatsQuery,
  useLazyGetProfileDistributionQuery,
  useLazyGetCitiesPerCountryQuery,
  useLazyGetSpendingMetricsQuery,
  useLazyGetTechItemsQuery,
  useLazyGetOrderedBySavesQuery,
  useLazyGetToiletryDistributionQuery,
  useLazyGetDashboardTableQuery,
  useLazyGetTopTenPackingQuery,
  useLazyGetTravellerProfileTableQuery,
  useLazyGetPackingListStatsCardQuery,
  useLazyGetPackingListAnalyticsQuery,
  useLazyGetDestinationAnalyticsQuery,
  useLazyGetMonthlyGrowthRateQuery,
  useLazyGetActivityDistributionQuery,
  useLazyGetActivityQuery,
  useLazyGetNationalityCompositionQuery,
  useLazyGetPackingStyleDistributionQuery,
  useLazyGetTagsQuery,
  useLazyGetFilterQuery,
  useGetCountSavedListQuery,
  useLazyGetAllNotificationQuery,
  useLazyGetUnReadAllNotificationQuery,
  useLazyGetSavedPackingListQuery,
  useLazyGetPackingListSearhQuery,
  usePackingDefaultGetQuery,
  usePartialPackingQuery,
  usePerfectPackingQuery,
  useGetTopSectionQuery,
  usePrimaryBadgesQuery,
  useSpecialBadgesQuery,
  useGenderPackingQuery
} = api;
